import {complement} from "ramda";

export default complement;